module.exports = __webpack_public_path__ + "f0b2efd69900f1e5286ea6fb7101d5c0.pdf";